export interface ITagAttribute {
	text?: string;
	textColor?: string;
	icon?: JSX.Element;
	backgroundColor?: string;
	gradientColor?: {
		start: string;
		end: string;
	};
	subTag?: string;
	bannerText?: string;
	bannerTextColor?: string;
	bannerBg?: string;
}

export interface IImageFiles {
	low: string;
	medium: string;
	high: string;
}
export interface BodyLayoutContext {
	setTriggerNotificationOffAlert: React.Dispatch<React.SetStateAction<boolean>>;
}

export enum EXCLUSIVE_TYPE {
	NONE = 'NONE',
	NEW_USER = 'NEW_USER',
}

export const EXCLUSIVE_TYPE_OPTIONS = [
	{ value: 'None', key: EXCLUSIVE_TYPE.NONE },
	{ value: 'New User Exclusive', key: EXCLUSIVE_TYPE.NEW_USER },
];

export const EXCLUSIVE_TYPE_MAPPER = EXCLUSIVE_TYPE_OPTIONS.reduce((acc, curr) => {
	acc[curr.key] = curr.value;
	return acc;
}, {} as Record<EXCLUSIVE_TYPE, string>);
